import React from 'react';
import Zoom from './zoom';
 
const  App = () =>  {
  const [ join, setJoinMeeting] = React.useState(false)
  return (
    <div>      
    {
      join
      ?
       <Zoom/>
      :
      <button
        onClick={() => setJoinMeeting(!join)}
      >
        Join Meeting
      </button>
    }
    </div>
  );
}

export default App;
